<template>
    <v-dialog class="modal-dialog"
      v-model="dialog"
      @keydown.esc="closeModal"
      width="unset"
      persistent
    >
      <v-card>
        <div>
          <v-card-title class="modal-headline" id="dialogTitle">{{dialogTitle}}
            <v-spacer></v-spacer>
            <v-btn :ripple="false" icon ref="dialogHeaderCloseBtn" @click="closeModal" @keydown="dialogHeaderCloseKeydown($event)" aria-label="Close">
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-card-title>
        </div>
        <v-card-text v-html="dialogMessage" id="dialogMessage">
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class='modal-confirm-button'
            text="text"
            @click="confirm"
            v-if="dialogButtonConfirmText"
            ref="dialogButtonYes"
          >
            {{dialogButtonConfirmText}}
          </v-btn>
          <v-btn class='modal-confirm-button'
            text="text"
            @click="closeModal"
            ref="dialogButtonClose"
            @keydown="dialogButtonCloseKeydown($event)"
          >
            {{dialogButtonText}}
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

export default {
  name: 'ModalDialog',
  props: ['dialog', 'dialogMessage', 'dialogTitle', 'dialogButtonText', 'dialogButtonConfirmText'],
  methods: {
    closeModal () {
      this.$emit('closemodal', this.dialogTitle)
    },
    confirm () {
      this.$emit('confirmmodal')
    },
    dialogHeaderCloseKeydown (event) {
      if (event.shiftKey && event.keyCode === 9) {
        event.preventDefault()
        this.$refs.dialogButtonClose.$el.focus()
      }
    },
    dialogButtonCloseKeydown (event) {
      if (event.shiftKey && event.keyCode === 9) {
        event.preventDefault()
        if (this.dialogButtonConfirmText.length !== 0) {
          this.$refs.dialogButtonYes.$el.focus()
        } else {
          this.$refs.dialogHeaderCloseBtn.$el.focus()
        }
      } else if (event.keyCode === 9) {
        event.preventDefault()
        this.$refs.dialogHeaderCloseBtn.$el.focus()
      }
    }
  },
  watch: {
    dialog () {
      this.$nextTick(() => {
        if (this.dialog) {
          this.$nextTick(() => {
            this.$refs.dialogHeaderCloseBtn.$el.focus()
          })
        }
      })
    }
  }
}

</script>
<style lang="scss">
.modal-confirm-button {
  background-color: var(--primary-btn-bg-color) !important;
  color: var(--primary-btn-text-color) !important;
}
.modal-headline{
  background-color: var(--primary-color) !important;
  color: var(--primary-bg-text-color) !important;
}
.v-dialog>.v-card>.v-card__text{
  padding: 8px;
}
.closeBtn-description {
  display: none !important;
}
#dialogMessage {
  padding: 10px;
}
</style>
